import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Config from "conFig.js";
const BCphuongtienttable = React.memo(function BCphuongtienttable(props) {
  const classes = useStyles();
  const { thangnam } = props;
  const [baocao, setBaocao] = React.useState([]);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getbaocao = () => {
    if (thangnam) {
      var url =
        Config.backend +
        "/api/Phuongtien/bcpl04qd34?thangnam=" +
        String(thangnam.$M + 1).padStart(2, "0") +
        "/" +
        thangnam.$y +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          if (data.length > 0) {
            setBaocao(data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  React.useEffect(() => {
    getbaocao();
  }, [thangnam]);
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th}>STT</th>
          <th className={classes.tablebc_th} style={{ width: "25vw" }}>
            Nội dung
          </th>
          <th className={classes.tablebc_th}>ĐVT</th>
          <th className={classes.tablebc_th}>01</th>
          <th className={classes.tablebc_th}>02</th>
          <th className={classes.tablebc_th}>03</th>
          <th className={classes.tablebc_th}>04</th>
          <th className={classes.tablebc_th}>05</th>
          <th className={classes.tablebc_th}>06</th>
          <th className={classes.tablebc_th}>07</th>
          <th className={classes.tablebc_th}>08</th>
          <th className={classes.tablebc_th}>09</th>
          <th className={classes.tablebc_th}>10</th>
          <th className={classes.tablebc_th}>11</th>
          <th className={classes.tablebc_th}>12</th>
          <th className={classes.tablebc_th}>Cả năm</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        {baocao.map((row, i) => {
          return row.dvt === null ? (
            <tr key={i}>
              <td className={classes.tablesotan_td}>{row["tt_hienthi"]}</td>
              <td className={classes.tablesotan_td} colSpan="15">
                {row["noidung"]}
              </td>
            </tr>
          ) : (
            <tr key={i}>
              <td className={classes.tablesotan_td}>{row["tt_hienthi"]}</td>
              <td className={classes.tablesotan_td}>{row["noidung"]}</td>
              <td className={classes.tablesotan_td}>{row["dvt"]}</td>
              <td className={classes.tablesotan_td}>
                {Number(row["thang01"]).toLocaleString()}
              </td>
              <td className={classes.tablesotan_td}>
                {Number(row["thang02"]).toLocaleString()}
              </td>
              <td className={classes.tablesotan_td}>
                {Number(row["thang03"]).toLocaleString()}
              </td>
              <td className={classes.tablesotan_td}>
                {Number(row["thang04"]).toLocaleString()}
              </td>
              <td className={classes.tablesotan_td}>
                {Number(row["thang05"]).toLocaleString()}
              </td>
              <td className={classes.tablesotan_td}>
                {Number(row["thang06"]).toLocaleString()}
              </td>
              <td className={classes.tablesotan_td}>
                {Number(row["thang07"]).toLocaleString()}
              </td>
              <td className={classes.tablesotan_td}>
                {Number(row["thang08"]).toLocaleString()}
              </td>
              <td className={classes.tablesotan_td}>
                {Number(row["thang09"]).toLocaleString()}
              </td>
              <td className={classes.tablesotan_td}>
                {Number(row["thang10"]).toLocaleString()}
              </td>
              <td className={classes.tablesotan_td}>
                {Number(row["thang11"]).toLocaleString()}
              </td>
              <td className={classes.tablesotan_td}>
                {Number(row["thang12"]).toLocaleString()}
              </td>
              <td className={classes.tablesotan_td}>
                {Number(row["canam"]).toLocaleString()}
              </td>
            </tr>
          );
        })}
        <tr>
          <td className={classes.tablesotan_td} colSpan="16">
            Tổng cộng
          </td>
        </tr>
        <tr>
          <td className={classes.tablesotan_td}>II</td>
          <td className={classes.tablesotan_td} colSpan="15">
            HÀNH KHÁCH
          </td>
        </tr>
        <tr>
          <td className={classes.tablesotan_td}>...</td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = baocao.length > 0 ? renderTableBody() : null;
  return (
    <div className={classes.table} style={{ height: "350px" }}>
      <table id="baocaohanghoaquacang" className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

BCphuongtienttable.propTypes = {
  thangnam: PropTypes.object,
};
export default BCphuongtienttable;
